// momentum-sparks.js
// Sparks loyalty tab for Momentum Hub
// Loaded via asset_url in momentum-hub.liquid

(function () {
  var LOYALTY_BASE = 'https://vivre-chat-production.up.railway.app/loyalty';
  var _sparksLoaded = false;

  var MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fmtDate(raw) {
    if (!raw) return '';
    var d = new Date(raw);
    var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return isNaN(d) ? '' : d.getDate() + ' ' + MON[d.getMonth()] + ' ' + d.getFullYear();
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0;';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch(e){}
    document.body.removeChild(ta);
  }

  // Attach token header to every fetch call in this file
  function tokHeaders(token, extra) {
    var h = extra || {};
    if (token) h['X-Customer-Token'] = token;
    return h;
  }

  function actionBtnHtml(id, label, disabled, extra) {
    var style = 'padding:7px 16px;border:1.5px solid ' + (disabled ? '#ddd' : '#1a1a1a') + ';border-radius:999px;font-size:12px;font-weight:600;color:' + (disabled ? '#ccc' : '#1a1a1a') + ';background:#fff;cursor:' + (disabled ? 'not-allowed' : 'pointer') + ';font-family:inherit;';
    return '<button ' + (id ? 'id="' + id + '" ' : '') + (disabled ? 'disabled ' : '') + (extra || '') + ' style="' + style + '">' + label + '</button>';
  }

  function renderDobSection(customer) {
    var hasDob = customer.dob_month && customer.dob_day;

    if (hasDob) {
      var monthName = MONTH_NAMES[customer.dob_month - 1] || '';
      return '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f2f2f2;">'
        + '<div>'
        + '<div style="font-size:14px;font-weight:700;color:#1a1a1a;">Birthday</div>'
        + '<div style="font-size:12px;color:#bbb;margin-top:2px;">' + esc(monthName) + ' ' + esc(customer.dob_day) + ' — to update, contact us</div>'
        + '</div>'
        + '</div>';
    }

    // Build month select
    var monthOpts = '<option value="">Month</option>';
    for (var m = 1; m <= 12; m++) {
      monthOpts += '<option value="' + m + '">' + MONTH_NAMES[m - 1] + '</option>';
    }

    // Build day select
    var dayOpts = '<option value="">Day</option>';
    for (var d = 1; d <= 31; d++) {
      dayOpts += '<option value="' + d + '">' + d + '</option>';
    }

    var selectStyle = 'border:1px solid #e0e0e0;border-radius:8px;padding:7px 10px;font-size:13px;font-family:inherit;color:#1a1a1a;background:#fff;outline:none;cursor:pointer;';

    return '<div style="padding:10px 0;border-bottom:1px solid #f2f2f2;">'
      + '<div style="font-size:14px;font-weight:700;color:#1a1a1a;margin-bottom:8px;">Birthday</div>'
      + '<div style="font-size:12px;color:#bbb;margin-bottom:10px;">Save your birthday to claim 200 Sparks each year during your birthday month.</div>'
      + '<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;">'
      + '<select id="mh-dob-month" style="' + selectStyle + '">' + monthOpts + '</select>'
      + '<select id="mh-dob-day" style="' + selectStyle + '">' + dayOpts + '</select>'
      + '<button id="mh-dob-save" style="padding:7px 16px;border:1.5px solid #1a1a1a;border-radius:999px;font-size:12px;font-weight:600;color:#1a1a1a;background:#fff;cursor:pointer;font-family:inherit;">Save</button>'
      + '</div>'
      + '<div id="mh-dob-result" style="margin-top:8px;display:none;"></div>'
      + '</div>';
  }

  function renderSparksPanel(customer, codes, transactions) {
    var bal = customer.points_balance || 0;
    var igClaimed = customer.ig_follow_claimed;
    var bdClaimed = customer.birthday_claimed_year;

    var sgNow = new Date(Date.now() + 8 * 60 * 60 * 1000);
    var currentMonth = sgNow.getUTCMonth() + 1;
    var currentYear = sgNow.getUTCFullYear();
    var isBdMonth = customer.dob_month && customer.dob_month === currentMonth;
    var bdAlreadyClaimed = bdClaimed === currentYear;

    var activeCodes = codes.filter(function(c) { return !c.used_at; });
    var usedCodes = codes.filter(function(c) { return c.used_at; });

    var html = '';

    // ── Balance card ──
    html += '<div class="mh-card">'
      + '<p class="mh-card-label">Sparks Balance</p>'
      + '<div style="font-size:40px;font-weight:700;letter-spacing:-1.5px;color:#1a1a1a;margin:4px 0 4px;">'
      + esc(bal.toLocaleString())
      + '</div>'
      + '<p style="font-size:13px;color:#bbb;margin:0;">1 Spark = SGD $1 spent</p>'
      + '</div>';

    // ── Active codes card ──
    if (activeCodes.length) {
      html += '<div class="mh-card">'
        + '<p class="mh-card-label">Your Codes</p>';
      activeCodes.forEach(function(c) {
        var rewardLabel = c.label || (c.reward === '10SGD' ? '$10 off' : c.reward === '20SGD' ? '$20 off' : '30% off');
        var applyUrl = 'https://vivreactivewear.com/discount/' + encodeURIComponent(c.code) + '?redirect=/cart';
        html += '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 0;border-bottom:1px solid #f2f2f2;flex-wrap:wrap;">'
          + '<div>'
          + '<div style="font-size:13px;font-weight:700;color:#1a1a1a;font-family:\'SF Mono\',\'Fira Code\',monospace;letter-spacing:0.4px;">' + esc(c.code) + '</div>'
          + '<div style="font-size:12px;color:#bbb;margin-top:2px;">' + esc(rewardLabel) + ' &middot; ' + (c.expires_at ? 'Valid until ' + fmtDate(c.expires_at) : 'Issued ' + fmtDate(c.issued_at)) + '</div>'
          + '</div>'
          + '<div style="display:flex;gap:6px;flex-shrink:0;">'
          + '<button class="mh-sparks-copy-btn mh-copy-btn" data-code="' + esc(c.code) + '">Copy</button>'
          + '<a href="' + esc(applyUrl) + '" style="padding:4px 12px;background:#1a1a1a;color:#fff;border-radius:6px;font-size:11px;font-weight:600;text-decoration:none;white-space:nowrap;display:inline-block;">Apply to cart</a>'
          + '</div>'
          + '</div>';
      });
      html += '</div>';
    }

    // ── Used codes ──
    if (usedCodes.length) {
      html += '<div class="mh-card">'
        + '<p class="mh-card-label">Used Codes</p>';
      usedCodes.forEach(function(c) {
        var rewardLabel = c.label || (c.reward === '10SGD' ? '$10 off' : c.reward === '20SGD' ? '$20 off' : '30% off');
        html += '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 0;border-bottom:1px solid #f2f2f2;flex-wrap:wrap;">'
          + '<div>'
          + '<div style="font-size:13px;font-weight:600;color:#bbb;font-family:\'SF Mono\',\'Fira Code\',monospace;letter-spacing:0.4px;text-decoration:line-through;">' + esc(c.code) + '</div>'
          + '<div style="font-size:12px;color:#ccc;margin-top:2px;">' + esc(rewardLabel) + ' &middot; Used ' + fmtDate(c.used_at) + '</div>'
          + '</div>'
          + '<span style="font-size:11px;font-weight:600;color:#ccc;padding:4px 10px;border:1px solid #eee;border-radius:999px;">Used</span>'
          + '</div>';
      });
      html += '</div>';
    }

    // ── Redeem card ──
    html += '<div class="mh-card">'
      + '<p class="mh-card-label">Redeem Sparks</p>';

    var rewards = [
      { key: '10SGD', cost: 300,  label: '$10 off',  desc: '300 Sparks' },
      { key: '20SGD', cost: 500,  label: '$20 off',  desc: '500 Sparks' },
      { key: '30PCT', cost: 1200, label: '30% off',  desc: '1,200 Sparks' }
    ];

    rewards.forEach(function(r) {
      var canRedeem = bal >= r.cost;
      html += '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f2f2f2;">'
        + '<div>'
        + '<div style="font-size:14px;font-weight:700;color:' + (canRedeem ? '#1a1a1a' : '#bbb') + ';">' + esc(r.label) + '</div>'
        + '<div style="font-size:12px;color:#bbb;margin-top:2px;">' + esc(r.desc) + '</div>'
        + '</div>'
        + '<button class="mh-sparks-redeem-btn" data-reward="' + esc(r.key) + '" data-cost="' + r.cost + '" data-label="' + esc(r.label) + '"'
        + (canRedeem ? '' : ' disabled')
        + ' style="padding:7px 16px;border:1.5px solid ' + (canRedeem ? '#1a1a1a' : '#ddd') + ';border-radius:999px;font-size:12px;font-weight:600;color:' + (canRedeem ? '#1a1a1a' : '#ccc') + ';background:#fff;cursor:' + (canRedeem ? 'pointer' : 'not-allowed') + ';font-family:inherit;transition:background 0.15s,color 0.15s;">'
        + 'Redeem'
        + '</button>'
        + '</div>';
    });

    html += '<div id="mh-sparks-redeem-result" style="margin-top:12px;display:none;"></div>';
    html += '</div>';

    // ── Earn more card ──
    html += '<div class="mh-card">'
      + '<p class="mh-card-label">Earn More Sparks</p>';

    // Birthday claim -- only show if DOB is set and it's birthday month
    if (customer.dob_month) {
      if (isBdMonth) {
        if (bdAlreadyClaimed) {
          html += '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f2f2f2;">'
            + '<div>'
            + '<div style="font-size:14px;font-weight:700;color:#bbb;">Birthday Bonus 🎂</div>'
            + '<div style="font-size:12px;color:#bbb;margin-top:2px;">200 Sparks — claimed this year</div>'
            + '</div>'
            + actionBtnHtml(null, 'Claimed', true)
            + '</div>';
        } else {
          html += '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f2f2f2;">'
            + '<div>'
            + '<div style="font-size:14px;font-weight:700;color:#1a1a1a;">Birthday Bonus 🎂</div>'
            + '<div style="font-size:12px;color:#bbb;margin-top:2px;">200 Sparks — it\'s your birthday month!</div>'
            + '</div>'
            + actionBtnHtml('mh-bd-btn', 'Claim', false)
            + '</div>';
        }
      }
      // If DOB is set but not birthday month, don't show birthday row at all
    }

    // IG follow
    if (!igClaimed) {
      html += '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f2f2f2;">'
        + '<div>'
        + '<div style="font-size:14px;font-weight:700;color:#1a1a1a;">Follow on Instagram</div>'
        + '<div style="font-size:12px;color:#bbb;margin-top:2px;">100 Sparks — one-time</div>'
        + '</div>'
        + actionBtnHtml('mh-ig-btn', 'Claim', false)
        + '</div>';
    } else {
      html += '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f2f2f2;">'
        + '<div>'
        + '<div style="font-size:14px;font-weight:700;color:#bbb;">Follow on Instagram</div>'
        + '<div style="font-size:12px;color:#bbb;margin-top:2px;">100 Sparks — already claimed</div>'
        + '</div>'
        + actionBtnHtml(null, 'Claimed', true)
        + '</div>';
    }

    html += '<div style="padding:10px 0;border-bottom:1px solid #f2f2f2;">'
      + '<div style="font-size:14px;font-weight:700;color:#bbb;">Place an order</div>'
      + '<div style="font-size:12px;color:#bbb;margin-top:2px;">1 Spark per $1 SGD spent</div>'
      + '</div>'
      + '<div style="padding:10px 0;border-bottom:1px solid #f2f2f2;">'
      + '<div style="font-size:14px;font-weight:700;color:#bbb;">Write a review</div>'
      + '<div style="font-size:12px;color:#bbb;margin-top:2px;">50 Sparks per review</div>'
      + '</div>';

    // DOB section -- always last in earn card
    html += renderDobSection(customer);

    html += '<div id="mh-sparks-earn-result" style="margin-top:12px;display:none;"></div>';
    html += '</div>';

    // ── Transaction history ──
    if (transactions.length) {
      html += '<div class="mh-card">'
        + '<p class="mh-card-label">History</p>';
      transactions.forEach(function(t) {
        var isEarn = t.points_delta > 0;
        var sign = isEarn ? '+' : '';
        var colour = isEarn ? '#1d7a45' : '#b35900';
        html += '<div style="display:flex;align-items:center;justify-content:space-between;padding:9px 0;border-bottom:1px solid #f5f5f5;">'
          + '<div>'
          + '<div style="font-size:13px;color:#555;">' + esc(t.description) + '</div>'
          + '<div style="font-size:11px;color:#ccc;margin-top:2px;">' + fmtDate(t.created_at) + '</div>'
          + '</div>'
          + '<div style="font-size:13px;font-weight:700;color:' + colour + ';white-space:nowrap;margin-left:12px;">'
          + sign + t.points_delta.toLocaleString() + ' Sparks'
          + '</div>'
          + '</div>';
      });
      html += '</div>';
    }

    return html;
  }

  function attachSparksListeners(cid, token) {
    // Copy buttons
    document.querySelectorAll('.mh-sparks-copy-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var code = btn.getAttribute('data-code');
        var done = function() {
          btn.textContent = 'Copied!';
          btn.classList.add('copied');
          setTimeout(function() { btn.textContent = 'Copy'; btn.classList.remove('copied'); }, 2000);
        };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(done).catch(function() { fallbackCopy(code); done(); });
        } else {
          fallbackCopy(code); done();
        }
      });
    });

    // Redeem buttons
    document.querySelectorAll('.mh-sparks-redeem-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var reward = btn.getAttribute('data-reward');
        var result = document.getElementById('mh-sparks-redeem-result');
        btn.disabled = true;
        btn.textContent = 'Redeeming…';

        fetch(LOYALTY_BASE + '/redeem', {
          method: 'POST',
          headers: tokHeaders(token, { 'Content-Type': 'application/json' }),
          body: JSON.stringify({ shopify_customer_id: cid, reward: reward })
        })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (d.success) {
            var applyUrl = 'https://vivreactivewear.com/discount/' + encodeURIComponent(d.discount_code) + '?redirect=/cart';
            result.style.display = 'block';
            result.innerHTML = '<div style="background:#e2f5e9;border:1px solid #a7e0bd;border-radius:8px;padding:12px 14px;">'
              + '<div style="font-size:13px;font-weight:700;color:#1d7a45;margin-bottom:6px;">Code generated!</div>'
              + '<div style="font-family:\'SF Mono\',\'Fira Code\',monospace;font-size:14px;font-weight:700;color:#1a1a1a;letter-spacing:0.5px;margin-bottom:8px;">' + esc(d.discount_code) + '</div>'
              + '<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:8px;">'
              + '<button class="mh-sparks-copy-btn mh-copy-btn" data-code="' + esc(d.discount_code) + '" style="padding:5px 12px;border:1px solid #d8d8d8;border-radius:6px;font-size:11px;font-weight:600;color:#666;background:#fff;cursor:pointer;font-family:inherit;">Copy</button>'
              + '<a href="' + esc(applyUrl) + '" style="padding:5px 14px;background:#1a1a1a;color:#fff;border-radius:6px;font-size:11px;font-weight:600;text-decoration:none;display:inline-block;">Apply to cart</a>'
              + '</div>'
              + '<div style="font-size:12px;color:#555;">Valid 90 days. New balance: <strong>' + d.new_balance.toLocaleString() + ' Sparks</strong></div>'
              + '</div>';
            btn.textContent = 'Redeemed';
            var newCopyBtn = result.querySelector('.mh-sparks-copy-btn');
            if (newCopyBtn) {
              newCopyBtn.addEventListener('click', function() {
                var code = newCopyBtn.getAttribute('data-code');
                var done = function() { newCopyBtn.textContent = 'Copied!'; setTimeout(function() { newCopyBtn.textContent = 'Copy'; }, 2000); };
                if (navigator.clipboard) { navigator.clipboard.writeText(code).then(done).catch(function() { fallbackCopy(code); done(); }); }
                else { fallbackCopy(code); done(); }
              });
            }
          } else {
            btn.disabled = false;
            btn.textContent = 'Redeem';
            result.style.display = 'block';
            result.innerHTML = '<p style="font-size:12px;color:#b00020;margin:0;">' + esc(d.error || 'Something went wrong.') + '</p>';
          }
        })
        .catch(function() {
          btn.disabled = false;
          btn.textContent = 'Redeem';
          var result = document.getElementById('mh-sparks-redeem-result');
          result.style.display = 'block';
          result.innerHTML = '<p style="font-size:12px;color:#b00020;margin:0;">Something went wrong. Please try again.</p>';
        });
      });
    });

    // Birthday claim
    var bdBtn = document.getElementById('mh-bd-btn');
    if (bdBtn) {
      bdBtn.addEventListener('click', function() {
        bdBtn.disabled = true;
        bdBtn.textContent = 'Claiming…';
        var result = document.getElementById('mh-sparks-earn-result');
        fetch(LOYALTY_BASE + '/birthday', {
          method: 'POST',
          headers: tokHeaders(token, { 'Content-Type': 'application/json' }),
          body: JSON.stringify({ shopify_customer_id: cid })
        })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (d.success) {
            bdBtn.textContent = 'Claimed';
            result.style.display = 'block';
            result.innerHTML = '<p style="font-size:13px;color:#1d7a45;font-weight:600;margin:0;">+200 Sparks added! New balance: ' + d.new_balance.toLocaleString() + '</p>';
          } else {
            bdBtn.disabled = false;
            bdBtn.textContent = 'Claim';
            result.style.display = 'block';
            result.innerHTML = '<p style="font-size:12px;color:#b00020;margin:0;">' + esc(d.error || 'Something went wrong.') + '</p>';
          }
        })
        .catch(function() { bdBtn.disabled = false; bdBtn.textContent = 'Claim'; });
      });
    }

    // IG follow claim
    var igBtn = document.getElementById('mh-ig-btn');
    if (igBtn) {
      igBtn.addEventListener('click', function() {
        igBtn.disabled = true;
        igBtn.textContent = 'Claiming…';
        var result = document.getElementById('mh-sparks-earn-result');
        fetch(LOYALTY_BASE + '/igfollow', {
          method: 'POST',
          headers: tokHeaders(token, { 'Content-Type': 'application/json' }),
          body: JSON.stringify({ shopify_customer_id: cid })
        })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (d.success) {
            igBtn.textContent = 'Claimed';
            result.style.display = 'block';
            result.innerHTML = '<p style="font-size:13px;color:#1d7a45;font-weight:600;margin:0;">+100 Sparks added! New balance: ' + d.new_balance.toLocaleString() + '</p>';
          } else {
            igBtn.disabled = false;
            igBtn.textContent = 'Claim';
            result.style.display = 'block';
            result.innerHTML = '<p style="font-size:12px;color:#b00020;margin:0;">' + esc(d.error || 'Something went wrong.') + '</p>';
          }
        })
        .catch(function() { igBtn.disabled = false; igBtn.textContent = 'Claim'; });
      });
    }

    // DOB save
    var dobSaveBtn = document.getElementById('mh-dob-save');
    if (dobSaveBtn) {
      dobSaveBtn.addEventListener('click', function() {
        var monthEl = document.getElementById('mh-dob-month');
        var dayEl   = document.getElementById('mh-dob-day');
        var result  = document.getElementById('mh-dob-result');
        var month   = parseInt(monthEl ? monthEl.value : 0);
        var day     = parseInt(dayEl ? dayEl.value : 0);

        if (!month || !day) {
          result.style.display = 'block';
          result.innerHTML = '<p style="font-size:12px;color:#b00020;margin:0;">Please select both month and day.</p>';
          return;
        }

        dobSaveBtn.disabled = true;
        dobSaveBtn.textContent = 'Saving…';
        result.style.display = 'none';

        fetch(LOYALTY_BASE + '/birthday/dob', {
          method: 'POST',
          headers: tokHeaders(token, { 'Content-Type': 'application/json' }),
          body: JSON.stringify({ shopify_customer_id: cid, dob_month: month, dob_day: day })
        })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (d.success) {
            // Reload the whole Sparks panel to reflect new DOB state
            _sparksLoaded = false;
            window.loadSparks(cid, token);
          } else {
            dobSaveBtn.disabled = false;
            dobSaveBtn.textContent = 'Save';
            result.style.display = 'block';
            result.innerHTML = '<p style="font-size:12px;color:#b00020;margin:0;">' + esc(d.error || 'Something went wrong.') + '</p>';
          }
        })
        .catch(function() {
          dobSaveBtn.disabled = false;
          dobSaveBtn.textContent = 'Save';
          result.style.display = 'block';
          result.innerHTML = '<p style="font-size:12px;color:#b00020;margin:0;">Something went wrong. Please try again.</p>';
        });
      });
    }
  }

  window.loadSparks = function(cid, token) {
    if (_sparksLoaded) return;
    var panel = document.getElementById('mh-panel-sparks');
    if (!panel) return;
    panel.innerHTML = '<div style="text-align:center;padding:40px 0;"><div class="mh-spinner"></div></div>';

    Promise.all([
      fetch(LOYALTY_BASE + '/customer/' + encodeURIComponent(cid), { headers: tokHeaders(token) }).then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }),
      fetch(LOYALTY_BASE + '/codes/' + encodeURIComponent(cid), { headers: tokHeaders(token) }).then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }),
      fetch(LOYALTY_BASE + '/transactions/' + encodeURIComponent(cid), { headers: tokHeaders(token) }).then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    ])
    .then(function(results) {
      panel.innerHTML = renderSparksPanel(results[0], results[1], results[2]);
      attachSparksListeners(cid, token);
      _sparksLoaded = true;
    })
    .catch(function() {
      panel.innerHTML = '<div class="mh-card"><p style="color:#b00020;font-size:14px;margin:0;">Unable to load Sparks. Please try again later.</p></div>';
    });
  };
})();